var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('SidebarRider',{on:{"open-notification":_vm.openNotification,"logout":_vm.handleLogout}}),_c('v-main',[_c('ActiveTravelBanner',{attrs:{"role":"rider"}}),_c('div',{staticClass:"rider-content",class:{ 'rider-content--mobile': _vm.$vuetify.breakpoint.smAndDown }},[_c('router-view')],1)],1),_c('RiderFloatingChat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }